import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import _ from 'lodash';
import moment from 'moment-timezone';
import {
  Button,
  Dimmer,
  Grid,
  Header,
  Loader,
  Modal,
  Segment,
} from 'semantic-ui-react';
import { fetchM } from '../../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import Timestamp from '../../components/Timestamp';
import Countdown from '../../components/Countdown';
import BuyerCheckResult from '../../components/BuyerCheckResult';
import BuyerLoanCard from '../../components/BuyerLoanCard';
import BankersList from '../modals/BankersList';
import InviteBankerForm from '../modals/InviteBankerForm';
import UpdateCaseStatus from '../modals/UpdateCaseStatus';
import BookingStatusNotes from '../modals/BookingStatusNotes';
// import BuyerBankerChat from '../modals/BuyerBankerChat';
import BUYER_BOOKING_STATUSES, {
  BUYER_BOOKING_STATUS_DRAFT_OPTION,
  BUYER_BOOKING_STATUS_NEW_OPTION,
  BUYER_BOOKING_STATUS_CHECK_LINKED_OPTION,
  BUYER_BOOKING_STATUS_LOAN_SUBMITTED_OPTION,
  BUYER_BOOKING_STATUS_SOLD_OPTION,
  BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION,
  BUYER_BOOKING_STATUS_CANCELLED_OPTION,
  BUYER_BOOKING_STATUS_EXPIRED_OPTION,
} from '../../constants/buyerBookingStatuses';
// structs
import BOOKING_DEFAULT from '../../structs/booking';

import { decodeSearch, encodeSearch } from '../../utils/url';
import { bankCaseLoanAmount, bankCaseLoanAmountPayload } from '../../utils/loanAmount';
import { spaFullNumber } from '../../utils/amount';

class BuyerBooking extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    bookingID: PropTypes.string,
    setLoading: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    isMobile: PropTypes.bool,
    booking: PropTypes.shape({}),
    bankCaseStates: PropTypes.shape({
      data: PropTypes.array,
    }),
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  }
  static mapStateToProps = state => ({
    bankCaseStates: state.bankCaseStates,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const booking = Object.assign({}, BOOKING_DEFAULT, props.booking);
    const projectCurrencies = booking.project.projectCurrency;
    return {
      loading,
      booking,
      projectCurrencies,
    };
  }
  constructor(props) {
    super(props);
    const state = BuyerBooking.getPropsToState(props);
    this.state = {
      ...state,
      data: null,
      resendable: false,
      resendModal: false,
      showAddBanker: false,
      selectedBankID: 0,
      showInviteBanker: false,
      showUpdateBankCase: false,
      bookingStatusModal: false,
      selectedBankCase: null,
      updateStatus: '',
      // showBankerChat: false,
      // selectedLoan: null,
    };
    this.countdown = null;
  }
  componentDidMount() {
    const { booking } = this.props;
    if (booking && booking.buyerProfileID) {
      this.fetchBuyerBooking();
    }
  }
  componentWillReceiveProps(nextProps) {
    const state = BuyerBooking.getPropsToState(nextProps);
    const { booking, bookingID } = nextProps;
    const needFetch = bookingID !== this.props.bookingID && booking && booking.buyerProfileID;
    this.setState({ ...state }, () => {
      if (needFetch) {
        this.fetchBuyerBooking(bookingID);
      }
    });
  }
  componentWillUnmount() {
    if (this.countdown) {
      this.countdown.clearTimer();
    }
  }
  setLoading = (loading = false) => {
    if (this.props.setLoading) {
      return this.props.setLoading(loading);
    }
    return Promise.resolve();
  }
  setComponentState = (state = {}) => new Promise((res) => {
    this.setState(state, () => {
      res(state);
    });
  });
  getPrimaryPurchaser = (list, id) => {
    if (list.length > 0) {
      return list.find(l => l.id === id);
    }
    return null;
  }
  setTimer = (data = this.state.data) => {
    if (this.countdown) {
      const timeout = this.calculateTimeout(data);
      if (timeout > 0) {
        this.countdown.startTimer(timeout);
      } else {
        this.countdown.stopTimer();
      }
    }
  }
  async fetchBuyerBooking(xid = this.props.bookingID) {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${xid}/buyer/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      await this.setComponentState({ data });
      await this.setTimer(data);
    }
    await this.setLoading(false);
  }
  async resendSMS() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/buyer/notify/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      await this.setComponentState({ data });
      await this.setTimer(data);
    }
    await this.setLoading(false);
  }
  async addBanker(banker) {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/buyer/banker/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(banker),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      await this.setComponentState({ data });
    }
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: 'Assign Success', message: `Banker ${banker.name} is successfully assigned.` }));
  }
  async updateBankCase(statusNote = '', loanAmount = '0') {
    await this.setLoading(true);
    const { store } = this.context;
    const { selectedBankCase, updateStatus } = this.state;
    const body = Object.assign(selectedBankCase, bankCaseLoanAmountPayload(loanAmount), {
      status: updateStatus,
      statusNote,
    });
    try {
      await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/loan_trackers/bank_cases/${selectedBankCase.code}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(body),
      }));
    } catch (err) {
      await this.setLoading(false);
      await this.setComponentState({
        selectedBankCase: null,
        updateStatus: '',
      });
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: 'Update Success', message: `${selectedBankCase.bank.shortName}'s case is successfully updated.` }));
    await this.setComponentState({
      selectedBankCase: null,
      updateStatus: '',
    });
    await this.fetchBuyerBooking();
  }
  async nudgeBankCase(bankCase) {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/loan_trackers/bank_cases/${bankCase.code}/nudge/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      store.dispatch(flashSuccessMessage({ header: 'Nudge Success', message: `${bankCase.bank.shortName}'s case is successfully nudged.` }));
    }
    await this.setLoading(false);
    await this.fetchBuyerBooking();
  }
  async updateBooking(booking, xid = this.props.bookingID) {
    await this.setLoading(true);
    const { store } = this.context;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${xid}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(booking),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    const data = await res.json();
    await this.setLoading(false);
    const query = decodeSearch(this.props.location.search);
    store.dispatch(push(`/bookings/${data.id}/?${encodeSearch(query)}`));
    store.dispatch(flashSuccessMessage({ header: 'Cancellation Success', message: `Booking ${data.code} successfully cancelled.` }));
    this.fetchBuyerBooking();
  }
  async linkExistingBooking(xid = this.props.bookingID) {
    await this.setLoading(true);
    const { store } = this.context;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${xid}/buyer/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    const data = await res.json();
    await this.setLoading(false);
    const query = decodeSearch(this.props.location.search);
    store.dispatch(push(`/bookings/${data.id}/?${encodeSearch(query)}`));
    store.dispatch(flashSuccessMessage({ header: 'Booking linked successfully', message: `Booking ${data.code} is now linked to MHub Buyer app.` }));
    this.fetchBuyerBooking();
  }
  handleBookingStatusChange = (event, { name, value }) => {
    const { booking } = this.state;
    booking[name] = value;
    this.setState({ booking, bookingStatusModal: true });
  }
  handleNotesChange = (event, { name, value }) => {
    const { booking } = this.state;
    booking[name] = value;
    this.setState({ booking });
  }
  handleCheckboxChange = (event, { checked }) => {
    const { booking } = this.state;
    booking.isCancelPending = checked;
    this.setState({ booking });
  }
  handleConfirmBookingStatus = () => {
    const { booking } = this.state;
    const newBooking = {
      statusID: booking.statusID,
      remarkInternal: booking.remarkInternal,
    };
    if (booking.statusID === 'sold_spa_signed' || booking.statusID === 'cancelled_developer') {
      newBooking.isCancelPending = booking.isCancelPending;
    }
    this.setState({ bookingStatusModal: false }, () => this.updateBooking(newBooking));
  }
  handleCancelBookingStatus = () => {
    const booking = Object.assign({}, BOOKING_DEFAULT, this.props.booking);
    this.setState({ booking, bookingStatusModal: false });
  }
  handleShowResendModal = () => {
    const { resendModal } = this.state;
    if (!resendModal) {
      this.setState({ resendModal: true });
    }
  }
  handleCloseResendModal = () => {
    const { resendModal } = this.state;
    if (resendModal) {
      this.setState({ resendModal: false });
    }
  }
  handleConfirmResendModal = () => {
    const { resendModal } = this.state;
    if (resendModal) {
      this.setState({ resendModal: false }, () => this.resendSMS());
    }
  }
  handleShowAddBanker = (e, { loan }) => {
    e.preventDefault();
    this.setState({
      showAddBanker: true,
      selectedBankID: parseInt(loan.bank_id, 10),
    });
  }
  handleCloseAddBanker = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAddBanker: false,
    });
  }
  handleAddBanker = (e, bankers) => {
    e.preventDefault();
    this.setState({ showAddBanker: false }, () => this.addBanker(bankers[0]));
  }
  handleShowInviteBanker = (e) => {
    e.preventDefault();
    this.setState({
      showInviteBanker: true,
    });
  }
  handleCloseInviteBanker = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showInviteBanker: false,
    });
  }
  handleInviteBanker = (e, validations, banker) => {
    e.preventDefault();
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      const { store } = this.context;
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
      return;
    }
    this.setState({ showInviteBanker: false, showAddBanker: false }, () => {
      this.addBanker(banker);
    });
  }
  handleShowUpdateBankCase = (e, selectedBankCase, updateStatus = '') => {
    e.preventDefault();
    this.setState({
      showUpdateBankCase: true,
      selectedBankCase,
      updateStatus,
    });
  }
  handleCloseUpdateBankCase = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showUpdateBankCase: false,
      selectedBankCase: null,
      updateStatus: '',
    });
  }
  handleUpdateBankCase = (e, statusNote = '', loanAmount = '0') => {
    this.setState({
      showUpdateBankCase: false,
    }, () => {
      this.updateBankCase(statusNote, loanAmount);
    });
  }
  // handleShowBankerChat = (e, selectedLoan) => {
  //   e.preventDefault();
  //   this.setState({
  //     showBankerChat: true,
  //     selectedLoan,
  //   });
  // }
  // handleCloseBankerChat = (e) => {
  //   if (e) { e.preventDefault(); }
  //   this.setState({
  //     showBankerChat: false,
  //     selectedLoan: null,
  //   });
  // }
  handleNudge = (e, data) => {
    this.nudgeBankCase(data);
  }
  handleLinkBooking = () => this.linkExistingBooking();
  checkBanks = (bank) => {
    const { selectedBankID } = this.state;
    return bank.id !== selectedBankID;
  }
  checkBankers = (banker, bankers) => {
    const index = bankers.findIndex(i => i.id === banker.id);
    if (index > -1) {
      return false;
    }
    const { data } = this.state;
    if (data.loansList && data.loansList.items && data.loansList.items.length > 0) {
      const bankerIDs = data.loansList.items
        .filter(l => parseInt(l.loan.bank_id, 10) === this.state.selectedBankID)
        .map(l => l.banker_id);
      return bankerIDs.some(b => b === banker.id);
    }
    return false;
  }
  checkSelectedBankers = (banker) => {
    const { data } = this.state;
    if (data.loansList && data.loansList.items && data.loansList.items.length > 0) {
      const bankerIDs = data.loansList.items
        .filter(l => parseInt(l.loan.bank_id, 10) === this.state.selectedBankID)
        .map(l => l.banker_id);
      return bankerIDs.some(b => b === banker.id);
    }
    return false;
  }
  generateSteps = (data = this.state.data) => {
    const { status, status_logs: statusLogs } = data;
    let steps = BUYER_BOOKING_STATUSES.slice(0, 4);
    if (statusLogs && statusLogs.length > 0) {
      const cancelledStatuses = [
        BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION,
        BUYER_BOOKING_STATUS_CANCELLED_OPTION,
        BUYER_BOOKING_STATUS_EXPIRED_OPTION,
      ];
      if (cancelledStatuses.some((s) => s.value === status)) {
        steps = statusLogs.map(l => BUYER_BOOKING_STATUSES.find(s => s.value === l.n));
      }
    }
    return steps;
  }
  calculateTimeout = (data = this.state.data) => {
    const { sms_sent_at } = data;

    // get last sent at
    const lastSentAt = moment(sms_sent_at[sms_sent_at.length - 1]);

    // get minutes
    let minute = 1;
    const resendCount = sms_sent_at.length % 7;
    if (resendCount > 1) {
      minute = parseInt(2 ** (resendCount - 1), 10);
      if (minute >= 60) {
        minute = 60;
      }
    }
    const duration = moment.duration(minute, 'minutes');

    const now = moment();
    const nextResendAt = lastSentAt.add(minute, 'm');
    if (nextResendAt.isAfter(now)) {
      // calculate remaining time
      const seconds = moment.duration(nextResendAt.diff(now, 'seconds'));
      return duration.subtract(seconds).asSeconds();
    }

    return 0;
  }
  renderCountdownMessage = (time) => {
    if (time > 0) {
      const duration = moment.duration(time, 'seconds');
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      if (minutes > 0) {
        return ` (${minutes} m ${seconds} s)`;
      }
      return ` (${seconds} s)`;
    }
    return null;
  }
  renderSentAt = (sentAt, index, arr) => {
    const { data, resendable } = this.state;
    const { status, sms_new_message: message, purchaser_id, purchasers } = data;
    const primaryPurchaser = this.getPrimaryPurchaser(purchasers, purchaser_id);
    const renderButton = index === arr.length - 1 && (status === 'draft' || status === 'new');
    return (
      <div key={index}>
        <Timestamp
          timestamp={sentAt}
          format="DD MMM YYYY, hh:mm a"
        />
        {
          index === 0 ? (
            <p>Booking Confirmation Request has been sent to Purchaser <strong>{primaryPurchaser.name}</strong> at <strong>+{primaryPurchaser.mobile_prefix}{primaryPurchaser.mobile}</strong>.</p>
          ) : null
        }
        <p><strong>SMS: </strong>{message}</p>
        {
          renderButton ? (
            <Button
              primary
              onClick={this.handleShowResendModal}
              disabled={!resendable}
            >
              Resend
              <Countdown
                ref={(ref) => { this.countdown = ref; }}
                message={this.renderCountdownMessage}
                onStart={() => { this.setState({ resendable: false }); }}
                onComplete={() => { this.setState({ resendable: true }); }}
              />
            </Button>
          ) : null
        }
      </div>
    );
  }
  renderCreditCheckStep = (timestamp, name) => {
    const { isMobile } = this.props;
    const { data, projectCurrencies } = this.state;
    const { check } = data;
    return (
      <div>
        {
          timestamp ? (
            <Timestamp
              timestamp={timestamp}
              format="DD MMM YYYY, hh:mm a"
            />
          ) : null
        }
        {
          check ? (
            <p>Purchaser <strong>{name}</strong> completed <strong>Buyer Eligibility Screening Test (BEST)</strong>.</p>
          ) : (
            <p>Pending <strong>Buyer Eligibility Screening Test (BEST)</strong> from Purchaser <strong>{name}</strong>.</p>
          )
        }
        {
          check ? (
            <BuyerCheckResult
              data={check}
              isMobile={isMobile}
              projectCurrencies={projectCurrencies}
            />
          ) : null
        }
      </div>
    );
  }
  renderLoanApplicationsStep = (timestamp, name, code, isSold = false) => {
    const { booking, bankCaseStates, loading } = this.props;
    const {
      data,
      projectCurrencies,
      showAddBanker,
      selectedBankID,
      showInviteBanker,
      showUpdateBankCase,
      selectedBankCase,
      updateStatus,
      // showBankerChat,
      // selectedLoan,
    } = this.state;
    const { loansList } = data;
    return (
      <div>
        <BankersList
          open={showAddBanker}
          onClose={this.handleCloseAddBanker}
          onConfirm={this.handleAddBanker}
          projectID={booking.projectID}
          bankID={selectedBankID}
          bankerOnCheck={this.checkBankers}
          bankerOnCheckSelected={this.checkSelectedBankers}
          limit={1}
          extraNode={(
            <Button
              floated="left"
              onClick={this.handleShowInviteBanker}
              content="Invite"
            />
          )}
        />
        <InviteBankerForm
          ref={(ref) => { this.form = ref; }}
          open={showInviteBanker}
          onClose={this.handleCloseInviteBanker}
          onConfirm={this.handleInviteBanker}
          bankOnCheck={this.checkBanks}
        />
        <UpdateCaseStatus
          open={showUpdateBankCase}
          onClose={this.handleCloseUpdateBankCase}
          onConfirm={this.handleUpdateBankCase}
          bankerName={selectedBankCase ?
            selectedBankCase.banker.name : ''
          }
          statusName={bankCaseStates && updateStatus.length > 0 ?
            bankCaseStates.data.find(s => s.state === updateStatus).shortName
            : updateStatus
          }
          loanAmount={selectedBankCase ?
            `${bankCaseLoanAmount(selectedBankCase)}` : '0'
          }
          spaValue={parseFloat(spaFullNumber(booking)) || booking.spaValue}
        />
        {/* <BuyerBankerChat
          open={showBankerChat}
          data={selectedLoan}
          onClose={this.handleCloseBankerChat}
          isSold={isSold}
          disabled={loading}
        /> */}
        {
          timestamp ? (
            <Timestamp
              timestamp={timestamp}
              format="DD MMM YYYY, hh:mm a"
            />
          ) : null
        }
        <p>Purchaser <strong>{name}</strong> has submitted the loan applications for booking {code}.</p>
        {
          loansList && loansList.items && loansList.items.length > 0 ? (
            <Grid columns={3} doubling stackable>
              {
                _.uniqBy(loansList.items, 'loan_id').map((l, idx) => {
                  const loans = loansList.items.filter(la => la.loan_id === l.loan_id);
                  const bankCases = data.bankCases && data.bankCases.length > 0 ? data.bankCases.filter(b => b.bankID === parseInt(l.loan.bank_id, 10)) : [];
                  return (
                    <Grid.Column key={idx}>
                      <BuyerLoanCard
                        loans={loans}
                        bankCases={bankCases}
                        projectCurrencies={projectCurrencies}
                        onAssign={this.handleShowAddBanker}
                        onUpdateStatus={this.handleShowUpdateBankCase}
                        // onMessage={this.handleShowBankerChat}
                        onNudge={this.handleNudge}
                        isSold={isSold}
                        disabled={loading}
                      />
                    </Grid.Column>
                  );
                })
              }
            </Grid>
          ) : null
        }
      </div>
    );
  }
  renderSoldStep = timestamp => (
    <div>
      {
        timestamp ? (
          <Timestamp
            timestamp={timestamp}
            format="DD MMM YYYY, hh:mm a"
          />
        ) : null
      }
      <Segment className="sold">
        Unit is marked as Sold
      </Segment>
    </div>
  )
  renderRequestCancelledAt = (timestamp, name, code, renderButton = false) => (
    <div>
      {
        timestamp ? (
          <Timestamp
            timestamp={timestamp}
            format="DD MMM YYYY, hh:mm a"
          />
        ) : null
      }
      <p>Purchaser <strong>{name}</strong> requested to cancel booking {code}.</p>
      {
        renderButton ? (
          <Button
            color="red"
            onClick={e => this.handleBookingStatusChange(e, { name: 'statusID', value: 'cancelled_developer' })}
            disabled={this.state.loading}
          >
            Cancel &amp; Release Unit
          </Button>
        ) : null
      }
    </div>
  )
  renderStepContent = (statusOpt, index, statuses, activeIndex) => {
    if (index > activeIndex) {
      return [];
    }
    const { data } = this.state;
    const {
      sms_sent_at, loansList,
      status_logs: statusLogs,
      code, purchasers, purchaser_id, unit,
    } = data;
    const primaryPurchaser = this.getPrimaryPurchaser(purchasers, purchaser_id);
    let list = [];
    let updatedAt = null;
    let requestCancelledAt = null;
    if (statusLogs && statusLogs.length > 0) {
      if (statusLogs.some(l => l.n === statusOpt.value)) {
        updatedAt = statusLogs.find(l => l.n === statusOpt.value).at;
      }
      if (statusLogs.some(l => l.n === BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION.value)) {
        requestCancelledAt = statusLogs.find(l => l.n === BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION.value).at;
      }
    }
    switch (statusOpt.value) {
      case BUYER_BOOKING_STATUS_NEW_OPTION.value:
        list = sms_sent_at.map(this.renderSentAt);
        break;
      case BUYER_BOOKING_STATUS_CHECK_LINKED_OPTION.value:
        list.push(this.renderCreditCheckStep(updatedAt, primaryPurchaser.name));
        break;
      case BUYER_BOOKING_STATUS_LOAN_SUBMITTED_OPTION.value:
        if (loansList && loansList.items && loansList.items.length > 0) {
          list.push(this.renderLoanApplicationsStep(updatedAt, primaryPurchaser.name, code, activeIndex > index));
        }
        break;
      case BUYER_BOOKING_STATUS_SOLD_OPTION.value:
        list.push(this.renderSoldStep(updatedAt));
        break;
      case BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION.value:
        list.push(this.renderRequestCancelledAt(requestCancelledAt, primaryPurchaser.name, code, true));
        break;
      case BUYER_BOOKING_STATUS_CANCELLED_OPTION.value:
        if (requestCancelledAt) {
          list.push(this.renderRequestCancelledAt(requestCancelledAt, primaryPurchaser.name, code, false));
        }
        list.push((
          <div>
            <Timestamp
              timestamp={updatedAt}
              format="DD MMM YYYY, hh:mm a"
            />
            <Segment className="cancelled">
              Booking {code} is cancelled.
            </Segment>
          </div>
        ));
        break;
      case BUYER_BOOKING_STATUS_EXPIRED_OPTION.value:
        list.push((
          <div>
            <Timestamp
              timestamp={updatedAt}
              format="DD MMM YYYY, hh:mm a"
            />
            <Segment className="cancelled">
              Booking {code} has expired, and the reserved unit {unit.reference} has been released.
            </Segment>
          </div>
        ));
        break;
      default:
        break;
    }
    return list;
  }
  renderStep = (statusOpt, index, statuses) => {
    const { data } = this.state;
    let { status } = data;
    if (status === BUYER_BOOKING_STATUS_DRAFT_OPTION.value) {
      status = BUYER_BOOKING_STATUS_NEW_OPTION.value;
    }
    const classNames = ['buyer-section'];
    let activeIndex = index;
    if (statusOpt.value === status) {
      classNames.push('active');
    } else {
      activeIndex = statuses.findIndex(s => s.value === status);
    }
    if (
      activeIndex > index
      || statusOpt === BUYER_BOOKING_STATUS_CANCELLED_OPTION
      || statusOpt === BUYER_BOOKING_STATUS_EXPIRED_OPTION
    ) {
      classNames.push('done');
    }
    const renderBorder = index < statuses.length - 1;

    const list = this.renderStepContent(statusOpt, index, statuses, activeIndex);
    if (list.length < 1) {
      classNames.push('expand');
    }
    return (
      <Grid.Row key={index} className={classNames.join(' ')}>
        <Grid.Column
          className="buyer-title"
          mobile={1}
          tablet={3}
          computer={3}
          textAlign="right"
        >
          {statusOpt.text}
        </Grid.Column>
        <Grid.Column
          className="buyer-title"
          mobile={15}
          tablet={13}
          computer={13}
        >
          {statusOpt.text}
        </Grid.Column>
        {
          list.length > 0 || renderBorder ? (
            <Grid.Column
              mobile={1}
              tablet={3}
              computer={3}
              className="buyer-border"
            />
          ) : null
        }
        {
          list.length > 0 ? (
            <Grid.Column
              mobile={15}
              tablet={13}
              computer={13}
              className="buyer-item-list"
            >
              <Grid columns={1}>
                {
                  list.map((l, li) => (
                    <Grid.Column
                      key={li}
                      className="buyer-item"
                    >
                      {l}
                    </Grid.Column>
                  ))
                }
              </Grid>
            </Grid.Column>
          ) : null
        }
      </Grid.Row>
    );
  }
  render() {
    const { booking, data, resendModal, bookingStatusModal, loading } = this.state;
    if (!booking.buyerProfileID) {
      return (
        <Segment style={{ marginTop: '3rem' }} textAlign="center">
          <Header
            textAlign="center"
            as="h4"
          >
            <Header.Content>Link Booking to MHub Buyer App</Header.Content>
            <Header.Subheader>
              Buyer can perform Credit Check, Loan Selection, and keep track of their booking on Buyer App. More info on <a href="https://apps.mhub.my/buyer/" target="_blank">https://apps.mhub.my/buyer/</a>
            </Header.Subheader>
          </Header>
          <Button
            style={{ marginTop: '1rem' }}
            primary
            onClick={this.handleLinkBooking}
            loading={loading}
            disabled={loading}
          >
            Link Booking
          </Button>
        </Segment>
      );
    }
    if (!data) {
      return (
        <Grid className="buyer">
          <Dimmer style={{ zIndex: 20 }} active inverted>
            <Loader inline="centered">Loading</Loader>
          </Dimmer>
        </Grid>
      );
    }
    const statuses = this.generateSteps(data);
    return (
      <Grid className="buyer">
        <Modal
          basic
          open={resendModal}
          onClose={this.handleCloseResendModal}
          size="small"
        >
          <Header icon="send" content="Are you sure you want to resend?" />
          <Modal.Actions>
            <Button negative onClick={this.handleCloseResendModal} icon="cancel" content="Cancel" />
            <Button positive onClick={this.handleConfirmResendModal} icon="checkmark" content="Yes" />
          </Modal.Actions>
        </Modal>
        <BookingStatusNotes
          onNotesChange={this.handleNotesChange}
          onCheckboxChange={this.handleCheckboxChange}
          statusID={booking.statusID}
          notes={booking.remarkInternal}
          isCancelPending={booking.isCancelPending}
          onClose={this.handleCancelBookingStatus}
          onConfirm={this.handleConfirmBookingStatus}
          open={bookingStatusModal}
          data={booking}
        />
        <Dimmer style={{ zIndex: 20 }} active={this.props.loading} inverted>
          <Loader inline="centered">Loading</Loader>
        </Dimmer>
        {statuses.map(this.renderStep)}
      </Grid>
    );
  }
}

export default connect(BuyerBooking.mapStateToProps)(BuyerBooking);



// WEBPACK FOOTER //
// ./src/containers/BuyerBooking/index.jsx